import React, { useState } from 'react';
import { Alert, Box, Button, CircularProgress, Container, Paper, TextField, Typography } from '@mui/material';
import { LockResetOutlined } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/api';
import logo from '../assets/logo.svg';
import { usePortalText } from '../locales/portalTranslations';

const ResetPassword = () => {
  const pt = usePortalText();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async event => {
    event.preventDefault();
    setError('');
    if (password !== confirmPassword) return setError(pt('passwordMismatch'));
    setLoading(true);
    try {
      const response = await authService.resetPassword(params.get('token'), password);
      setMessage(response.message);
    } catch (requestError) {
      setError(requestError.response?.data?.errors?.join('. ') || requestError.response?.data?.message || 'Password could not be reset.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'background.default', p: 3 }}>
      <Container maxWidth="xs" disableGutters>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Box component="img" src={logo} alt="Motor Inspection" sx={{ height: 52, mb: 2 }} />
          <Typography component="h1" variant="h3">{pt('newPassword')}</Typography>
          <Typography color="text.secondary" sx={{ mt: 1 }}>{pt('newPasswordHelp')}</Typography>
        </Box>
        <Paper variant="outlined" sx={{ p: { xs: 3, sm: 4 } }}>
          {message ? (
            <StackSuccess message={message} onContinue={() => navigate('/')} />
          ) : (
            <Box component="form" onSubmit={submit}>
              {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
              <TextField fullWidth required type="password" label={pt('newPassword')} autoComplete="new-password" value={password} onChange={event => setPassword(event.target.value)} helperText={pt('passwordRules')} sx={{ mb: 2 }} />
              <TextField fullWidth required type="password" label={pt('confirmPassword')} autoComplete="new-password" value={confirmPassword} onChange={event => setConfirmPassword(event.target.value)} sx={{ mb: 3 }} />
              <Button fullWidth type="submit" variant="contained" disabled={loading || !params.get('token')} startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <LockResetOutlined />}>{pt('resetPassword')}</Button>
            </Box>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

const StackSuccess = ({ message, onContinue }) => { const pt = usePortalText(); return <Box><Alert severity="success" sx={{ mb: 3 }}>{message}</Alert><Button fullWidth variant="contained" onClick={onContinue}>{pt('continueSignIn')}</Button></Box>; };

export default ResetPassword;
